{ "id": "marteau-bouftou", "name": "Marteau du Bouftou", "slot": "arme", "set": "bouftou", "tier": 2, "price": 140, "icon": "icons/items/marteau-bouftou", "stats": { "vitalite": 20, "intelligence": 20 } }
